// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__YRyOQ","modalBody":"styles_modalBody__S6-pV","modalHeader":"styles_modalHeader__g2kpS"};